import { AXValidationRule, IValidationRuleResult } from '@acorex/ui';

export function normalizeValidator(validator: any): AXFValidatorProp {
  const v = new AXFValidatorProp();
  if (!validator) {
    return v;
  }
  v.enabled = validator.enabled !== false;
  v.items = (validator.items || []).map((item: any) => {
    const rule = new AXValidationRule();
    Object.assign(rule, item);
    return rule;
  });
  return v;
}

export class AXFValidatorProp {
  items: AXValidationRule[] = [];
  enabled: boolean = true;
  validate(value: any): Promise<IValidationRuleResult> {
    return new Promise<IValidationRuleResult>((resolve) => {
      Promise.all(
        this.items.map((c) => {
          const v: AXValidationRule = new AXValidationRule();
          Object.assign(v, c);
          c = v;
          return c.validate(value);
        })
      ).then((d) => {
        const error = d.find((c) => c.result === false);
        if (error) {
          resolve(error);
        } else {
          resolve({ result: true });
        }
      });
    });
  }

  clear() {}
  run() {}
}
